import React from 'react';

export interface LoadingStateProps {
  /** What is being fetched, e.g. "tus cursos". Kept short; it follows "Cargando". */
  what?: string;
  compact?: boolean;
}

/**
 * S1.3 — "still loading" said out loud.
 *
 * The alternative is what several screens did: render the empty initial state
 * while the request is in flight. A list with no rows yet and a list that is
 * genuinely empty look identical, so the screen answers a question it has not
 * heard the answer to — and the answer it gives is "you have nothing".
 *
 * `role="status"` so assistive tech announces the wait rather than leaving the
 * page silently unchanged.
 */
export const LoadingState: React.FC<LoadingStateProps> = ({ what, compact }) => (
  <p
    role="status"
    style={{
      color: '#666',
      margin: compact ? '8px 0' : '16px 0',
      fontSize: compact ? 14 : undefined,
    }}
  >
    {what ? `Cargando ${what}…` : 'Cargando…'}
  </p>
);

export default LoadingState;
